import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { ComparatorTrigger } from './ComparatorTrigger'
import { Color, comparatorStyles, theme } from '../../constants'
import { Div } from '../Div'
import { Flex } from '../Flex'
import { Icon, IconName } from '../Icon'
import { Text } from '../Text'

const ComparatorContainerBox = styled(Div)<{ color?: Color }>(
  ({ color = Color.BLUE }) => ({
    display: 'inline-flex',
    background: Color.WHITE,
    border: theme.border.style.thin,
    borderRadius: theme.border.radius.normal,
    boxShadow: theme.boxShadow.normal,
    color,
    fontSize: 14,
    overflow: 'hidden',
    userSelect: 'none',
  }),
)

const TitleElement = styled(Flex)(comparatorStyles)

export const ComparatorContainer = ({
  children,
  color,
  icon,
  label,
  onClose,
}: {
  children: ReactNode
  color?: Color
  icon: IconName
  label: string
  onClose?: () => void
}) => {
  return (
    <ComparatorContainerBox color={color}>
      <TitleElement gap={1} design="bold">
        <Icon name={icon} design="solid" />
        <Text bold>{label}</Text>
      </TitleElement>
      {children}
      {onClose && (
        <ComparatorTrigger onClick={onClose} design="light">
          <Icon name="XIcon" />
        </ComparatorTrigger>
      )}
    </ComparatorContainerBox>
  )
}
